<template>
    <div>
        <b-navbar fixed="top" toggleable="lg" type="dark" variant="info">
            <b-navbar-brand href="#">Solaris</b-navbar-brand>

            <b-navbar-toggle target="nav_collapse"/>

            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item to="/dashboard">Resum</b-nav-item>
                    <b-nav-item to="/counters">Comptadors</b-nav-item>
                    <b-nav-item v-if="editable" to="/configuration">Configuració</b-nav-item>
                    <b-nav-item v-if="editable" to="/utils">Utilitats</b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-button @click="newReading" v-if="showDashboardButtons() === true && editable" variant="dark">Nova Lectura</b-button>
                    &nbsp;
                    <b-button @click="refresh" v-if="showDashboardButtons() === true" variant="dark">Refrescar</b-button>
                    <b-nav-item-dropdown right>
                        <!-- Using button-content slot -->
                        <template slot="button-content">Usuari</template>
                        <b-dropdown-item v-on:click="logout">Sortir</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    import router from '../router'

    export default {
        name: "NavBar",
        methods: {
            logout: function () {
                //Remove user data and token from local storage and vuex store
                localStorage.user = null
                localStorage.token = null
                this.$store.commit('setUser', null)
                this.$store.commit('setToken', null)
                //Push to login
                router.push("/login")
            },
            refresh: function () {
                this.$eventBus.$emit('refreshPanels')
            },
            newReading: function() {
                this.$eventBus.$emit('newPanelReadings')
            },
            showDashboardButtons: function () {
                return (this.$route.path === '/dashboard')
            }
        },
        computed: {
            editable() {
                return this.$store.state.user.can_edit;
            },
        }
    }
</script>

<style scoped>

</style>